<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed, ref, watch } from 'vue';

const page = usePage();

const showFlash = ref(false);

const flash = computed(() => page.props.flash);

watch(page.props, val => {
    if (val?.flash) {
        showFlash.value = true;
    }
}, {
    immediate: true,
    deep: true,
});
</script>

<template>
    <div v-if="flash.message">
        <v-alert
            v-if="flash.message?.success"
            class="mb-5 mt-5"
            border="start"
            variant="tonal"
            type="success"
            :text="flash.message?.success"
        ></v-alert>
        <v-alert
            v-if="flash.message?.info"
            class="mb-5"
            border="start"
            variant="tonal"
            type="info"
            :text="flash.message?.info"
        ></v-alert>
        <v-alert
            v-if="flash.message?.error"
            class="mb-5"
            border="start"
            variant="tonal"
            type="error"
            :text="flash.message?.error"
        ></v-alert>
        <v-alert
            v-if="flash.message?.warning"
            class="mb-5"
            border="start"
            variant="tonal"
            icon="fas fa-exclamation-circle"
            type="warning"
        >
            <span v-html="flash.message?.warning"></span>
        </v-alert>
    </div>
</template>
